module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('p', {
    staticClass: "Prompt_-Writing-Prompts--Heading"
  }, [_vm._v("Writing Prompts: ")]), _vm._v(" "), _c('p', {
    staticClass: "Prompt_-Prompts-Name--Heading"
  }, [_vm._v("Gaining Perspective")]), _vm._v(" "), _c('p', {
    staticClass: "Prompt_Prompt-Intro-Para"
  }, [_vm._v("These exercises will help you review your life and gain a different kind of perspective on your past which can help you project into a brighter future for yourself. The word “perspective” implies clear vision and understanding, so when you complete these entries, keep that in mind. Part of what makes journaling such a positive activity is that it teaches you about yourself, who you are, and what makes you tick. Getting to know yourself is a process that many of us don’t think to engage in, but it’s one that will help seal your individuality and create a better understanding of your foundation"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("al")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("traits.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f6a43b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackAndResilient6.vue
// module id = 78
// module chunks = 0